/**
 * KnoVelo メインアプリケーションコンポーネント
 *
 * ルーティングとレイアウトを管理
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

// レイアウト
import MainLayout from './components/Layout/MainLayout';

// ページコンポーネント
import LoginPage from './components/Auth/LoginPage';
import Dashboard from './components/Dashboard/Dashboard';
import PageList from './components/Pages/PageList';
import PageDetail from './components/Pages/PageDetail';
import Settings from './components/Settings/Settings';
import Subscription from './components/Subscription/SubscriptionPage';

// ローディングコンポーネント
import LoadingScreen from './components/Layout/LoadingScreen';

/**
 * 認証済みユーザー専用ルート
 */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  // 認証状態を確認中
  if (loading) {
    return <LoadingScreen />;
  }

  // 未認証の場合はログインページへ
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

/**
 * 認証済みユーザーはリダイレクト
 */
function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  // 認証済みの場合はダッシュボードへ
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

/**
 * メインアプリコンポーネント
 */
function App() {
  return (
    <Routes>
      {/* 公開ルート */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* 保護されたルート */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        {/* ダッシュボード */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* ページ管理 */}
        <Route path="pages" element={<PageList />} />
        <Route path="pages/:pageId" element={<PageDetail />} />

        {/* 設定 */}
        <Route path="settings" element={<Settings />} />

        {/* サブスクリプション */}
        <Route path="subscription" element={<Subscription />} />
      </Route>

      {/* 404リダイレクト */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
